import React from 'react';

const RequiredMark = props => <span style={{ color: "red" }}>* </span>;

export default RequiredMark;


// WEBPACK FOOTER //
// ./src/commonComponents/RequiredMark.jsx